import {
	UPDATE_NOTIFICATION_PERMISSION,
	UPDATE_NOTIFICATION_PERMISSION_SUCCESS,
	UPDATE_NOTIFICATION_PERMISSION_FAIL,
	UPDATE_NOTIFICATION_PERMISSION_RESET,
} from '../actions/updateNotificationPermission';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const updateNotificationPermissionReducer = (state = initialState, action) => {
	switch (action.type) {
		case UPDATE_NOTIFICATION_PERMISSION:
			return {
				...state,
				apiState: 'loading',
			};
		case UPDATE_NOTIFICATION_PERMISSION_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case UPDATE_NOTIFICATION_PERMISSION_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case UPDATE_NOTIFICATION_PERMISSION_RESET:
			return initialState;
		default:
			return state;
	}
};

export default updateNotificationPermissionReducer;
